<template>
  <div
    :id="route.params.slug"
    :class="[
      'mx-auto promotion max-w-screen-xl',
      isConfirmationPage ? 'confirmation-page' : '',
    ]"
  >
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
  </div>
</template>

<style>
.promotion {
  &.confirmation-page {
    .organism.wysiwyg-block {
      @apply px-8 mt-20;
      h2 {
        @apply font-figtree text-gray-800 text-center text-3xl sm:text-[44px]  font-semibold mx-0 px-8 mb-7 leading-none;
      }

      p {
        @apply max-w-[805px] mx-auto text-justify text-lg font-figtree text-gray-500 leading-8 mb-0 sm:mb-8;
      }
    }
  }

  .disclaimer {
    @apply text-xs leading-none;
  }

  .organism.banner-bar {
    @apply mb-0;
  }

  .organism.brand-window {
    @apply mb-0;
  }
  .organism.brand-window-box-overlay {
    @apply mb-0;
  }

  .wysiwyg-block#flexible-content-header {
    @apply mt-20 mb-0;

    .text-content {
      @apply max-w-[60ch];
      h2 {
        @apply text-4xl font-bold text-center font-figtree text-gray-900 font-semibold;
      }
      h3 {
        @apply text-primary-500 text-center;
      }
    }
  }

  .organism.flexible-content-columns {
    @apply py-10 px-8 text-gray-500 gap-y-8;

    h3 {
      @apply text-gray-900 text-2xl font-semibold;
    }

    .description {
      p:first-of-type {
        @apply mb-4;
      }
    }

    img {
      @apply mx-auto mb-4;
    }

    p {
      @apply text-center;
    }

    .buttons {
      @apply justify-center;
    }
  }

  .wysiwyg-block.intro-text {
    @apply max-w-4xl mx-auto mb-10 px-4;

    h2 {
      @apply font-semibold font-figtree text-gray-900 leading-normal text-2xl lg:text-[33px];
    }
  }

  #collections-columns {
    @apply px-4 mb-28 text-black;

    .image-link {
      @apply hover:opacity-90;
    }

    img {
      @apply mb-4;
    }

    .title {
      @apply mb-4;

      &::before {
        @apply w-14 h-14 bg-no-repeat bg-contain inline-block relative top-4;
        content: "";
      }
    }

    .description p {
      @apply text-center text-lg font-figtree;
      letter-spacing: 0.2px;
      line-height: 1.222em;
    }

    .buttons {
      @apply !justify-center;
    }

    .buttons a {
      @apply uppercase;
    }
  }

  .organism.brand-window-text-overlay {
    @apply sm:min-h-[400px] mb-0;

    .content {
      @apply py-0;

      h2 {
        @apply text-secondary-500 first:mb-0 first:text-gray-900 drop-shadow-none text-4xl font-semibold sm:text-6xl font-figtree;
      }

      .content {
        @apply text-gray-500 text-xl;
      }
    }
  }

  .organism.split-content {
    @apply mb-0;
    .molecule.text {
      @apply flex flex-col;
      h2 {
        @apply mb-0;
      }
      h3 {
        @apply mb-6 text-gray-900;
      }
      h4 {
        @apply order-first font-bold uppercase font-figtree text-secondary-500 text-[17px];
      }
    }
  }
  .organism.tabbed-content-generic {
    .header-content {
      @apply flex flex-col;

      h2 {
        @apply order-last;
      }

      h3 {
        @apply order-last;
      }

      img {
        @apply max-w-[64px];
      }
    }

    .organism.wysiwyg-block {
      @apply pt-12 px-8;

      h3 {
        @apply text-2xl font-bold leading-none text-center text-gray-500 font-figtree sm:text-[32px];
        img {
          @apply max-w-[44px] relative -top-1 inline-block;
        }
      }
    }
  }

  .organism.site-map-cta {
    @apply mb-0;
  }

  .organism.form-cta {
    @apply mb-0 text-white;

    form {
      @apply text-white;
      label {
        @apply text-white;
      }

      .name.under-label {
        @apply hidden;
      }
    }
  }

  .organism-slider {
    @apply max-w-3xl;
  }

  .organism.wysiwyg-block {
    .buttons {
      @apply lg:justify-center;
    }
    .text-content {
      @apply mx-8 sm:mx-auto max-w-[805px] text-gray-500 text-lg;
    }
  }

  .organism.product-grid {
    &::before {
      @apply content-[''] block absolute inset-0 z-20;
    }
  }

  .promo-form-cta {
    img {
      @apply rounded-none h-auto aspect-auto;
    }

    .content {
      @apply relative;
    }

    .text {
      @apply 2xl:max-w-[60%];
    }

    .image-link,
    .image-container {
      @apply 2xl:absolute 2xl:top-20 2xl:left-0;
      /* margin-left: -100%; */

      img {
        @apply 2xl:relative 2xl:-left-full;
      }
    }

    .image-link img {
      @apply hover:scale-110 hover:-rotate-3;
    }
  }

  .neighborhoods-map {
    @apply mb-0;

    h2 {
      @apply font-semibold;
    }
  }
}
</style>

<script setup>
//import { useQuery } from "@vue/apollo-composable";
import { useAsyncQuery } from "#imports";
import { GET_PROMOTION_ORGANISMS } from "~/graphql/GetPromotionOrganisms";
import { storeToRefs } from "pinia";
const route = useRoute();
const { data, pending, error } = await useAsyncQuery(GET_PROMOTION_ORGANISMS, {
  uri: route.path,
});

const organisms = computed(() => {
  if (data.value && !data.value?.organisms) {
    navigateTo("/");
  }

  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;
</script>
